<template>
	<div>
		<section class="exam-content m0 cb pr mt15">
			<article class="fl exam-left">
				<h3 class="tc h3">{{ examPaperList.name }}</h3>
				<div class="paperIntroduce mb30">
				<el-row :span="24">
					<el-col :span="6">
						<span>试卷总分: {{ totalScore }} 分</span>
					</el-col>
					<el-col  :span="6">
						<span>试卷总题数: {{ totalQutestionNumber }}</span>
                        <span class="ml10">道</span>
					</el-col>
					<el-col  :span="8">
						<span>难易程度 {{ jiandannumber }}:{{ putongnumber }}:{{ kunnannumber }}</span>
						<span class="ml10">(&nbsp;简单:&nbsp;普通&nbsp;:困难)</span>
					</el-col>
				</el-row>
				<el-row :span="24" class="mt10">
					<el-col  :span="6">
						<span>考试时长: {{ duration }}</span>
                        <span class="ml10">分钟</span>
					</el-col>
					<el-col  :span="6">
						<span v-if="examTimes == -1">考试次数: 不限</span>
						<span v-if="examTimes != -1">考试次数: {{ examTimes }} 次</span>
					</el-col>
				</el-row>
			</div>
				<div class="exam-nav">
					<ul class="m0">
						<li class="first" v-if="questionList1.length > 0">
							<a href="javascript:;" :class="{ active: type == '001001' }" @click="menuBtn('001001')">单选题</a>
						</li>
						<li v-if="questionList2.length > 0">
							<a href="javascript:;" :class="{ active: type == '001002' }" @click="menuBtn('001002')">多选题</a>
						</li>
						<li v-if="questionList3.length > 0">
							<a href="javascript:;" :class="{ active: type == '001003' }" @click="menuBtn('001003')">判断题</a>
						</li>
						<li v-if="questionList4.length > 0">
							<a href="javascript:;" :class="{ active: type == '001004' }" @click="menuBtn('001004')">填空题</a>
						</li>
						<li v-if="questionList5.length > 0">
							<a href="javascript:;" :class="{ active: type == '001005' }" @click="menuBtn('001005')">简答题</a>
						</li>
						<li v-if="questionList6.length > 0">
							<a href="javascript:;" :class="{ active: type == '001006' }" @click="menuBtn('001006')">案例题</a>
						</li>
					</ul>
				</div>
				<div class="examOverscroll fl">
					<div class="option-question m0 active">
						<div v-show="type == '001001'">
							<!--<p class="explainText mt20 pl10">一、{{questionDescription['001001']}}</p>-->
							<div class="option-div" v-for="(questionsItem, index) in questionList1" :key="index">
								<i class="fl mr10 active">{{ index + 1 }}.</i>
								<h2 class="f14 fl" v-html="questionsItem.content">( ){{ questionsItem.content }}</h2>
								<div class="option-list-radio ml40 cb" v-for="(choicesItem, index) in questionsItem.choices" :key="index">
									<div class="oh">
										<el-radio v-model="questionsItem.userAnswer" :label="choicesItem.code">
											<span class="mr10">{{ choicesItem.code }}</span>
											<span v-html="choicesItem.content"> </span>
										</el-radio>
									</div>
								</div>
							</div>
						</div>
						<!--多选题-->
						<div v-show="type == '001002'">
							<p class="explainText mt20 pl10">一、{{ questionDescription["001002"] }}</p>
							<div class="option-div" v-for="(questionsItem, index) in questionList2" :key="index">
								<i class="fl mr10 active">{{ index + 1 }}</i>
								<h2 class="f14 fl mb15" v-html="questionsItem.content">( ){{ questionsItem.content }}</h2>
								<div class="option-list-radio ml40 cb">
									<el-checkbox-group v-model="questionsItem.userAnswer" @change="handleCheckedCitiesChange">
										<el-checkbox v-for="(choicesItem, index) in questionsItem.choices" :key="index" :label="choicesItem.code">
											<span class="mr10">{{ choicesItem.code }}</span>
											<span v-html="choicesItem.content"></span>
										</el-checkbox>
									</el-checkbox-group>
								</div>
							</div>
						</div>
						<!--判断题-->
						<div v-show="type == '001003'">
							<p class="explainText mt20 pl10">一、{{ questionDescription["001003"] }}</p>
							<div class="option-div" v-for="(questionsItem, index) in questionList3" :key="index">
								<i class="fl mr10 active">{{ index + 1 }}</i>
								<h2 class="f14 fl" v-html="questionsItem.content">( ){{ questionsItem.content }}</h2>
								<div class="option-list-radio ml40 cb" v-for="(choicesItem, index) in questionsItem.choices" :key="index">
									<div class="oh">
										<el-radio v-model="questionsItem.userAnswer" :label="choicesItem.code">
											<span v-html="choicesItem.content">{{ choicesItem.code }} {{ choicesItem.content }}</span>
										</el-radio>
									</div>
								</div>
							</div>
						</div>
						<!--填空题-->
						<div v-show="type == '001004'">
							<p class="explainText mt20 pl10">一、{{ questionDescription["001004"] }}</p>
							<div class="option-div option-div-tk" v-for="(questionsItem, index) in questionList4" :key="index">
								<div class="question-box">
									<i class="fl mr10 active">{{ index + 1 }}</i>
									<h2 class="f14 fl" v-html="questionsItem.content">( ){{ questionsItem.content }}</h2>
								</div>
								<p>
									<el-input
										type="text"
										class="mt30 mb10 ml10"
										v-for="(blanksNumbersItem, index) in questionsItem.blanksNumbers"
										:key="index"
										v-model="questionsItem.userAnswer"
										:label="blanksNumbersItem.code"
									></el-input>
								</p>
							</div>
						</div>
						<!--简答题-->
						<div v-show="type == '001005'">
							<p class="explainText mt20 pl10">一、{{ questionDescription["001005"] }}</p>
							<div class="option-div" v-for="(questionsItem, index) in questionList5" :key="index">
								<div class="question-box">
									<i class="fl mr10 active">{{ index + 1 }}</i>
									<h2 class="f14 fl" v-html="questionsItem.content">( ){{ questionsItem.content }}</h2>
								</div>
								<div class="textarea">
									<el-input type="textarea" v-model="questionsItem.userAnswer"></el-input>
								</div>
							</div>
						</div>
						<!--案例题-->
						<div v-show="type == '001006'">
							<p class="explainText mt20 pl10">一、{{ questionDescription["001006"] }}</p>
							<div class="option-div" v-for="(questionsItem, index) in questionList6" :key="index">
								<div class="question-box">
									<i class="fl mr10 active">{{ index + 1 }}</i>
									<h2 class="f14 fl" v-html="questionsItem.content">( ){{ questionsItem.content }}</h2>
								</div>
								<div class="textarea">
									<el-input type="textarea" v-model="questionsItem.userAnswer"></el-input>
								</div>
							</div>
						</div>
					</div>
				</div>
			</article>
			<!-- <div class="page-bj cb"></div> -->
		</section>
	</div>
</template>
<style>
.explainText {
	height: 40px;
	background: #fbf3e8;
	line-height: 40px;
	margin: 0 auto;
}

.option-div .el-radio,
.option-div .el-checkbox {
	white-space: inherit !important;
	line-height: 25px;
	float: left;
}
</style>
<script>
import ft from "../Footer";
import headTop from "../Top";
import "../../../static/css/exam-content.css";
//加载组件面板
import { Loading } from "element-ui";
//倒计时
import CountDown from "vue2-countdown";
//全局对象 ... 结束时一定要清除.
let FREQUENCY_TIMER;

export default {
	data() {
		return {
			intervalId: 0,
			count: 0,
			examPaperList: {},
			questionTypeSummaries: [],
			questionList1: [],
			questionList2: [],
			questionList3: [],
			questionList4: [],
			questionList5: [],
			questionList6: [],
			jiandannumber: 0,
			putongnumber: 0,
			kunnannumber: 0,
			//总分
			totalScore: 0,
			//总题目数
			totalQutestionNumber: 0,
			//考试次数
			examTimes: 0,
			//时长
			duration: 0,
			questionDescription: [],
			type: "001001",
			types: "001001",
			realName: "",
			userHeadImagUrl: "",
			//考试时长 (分钟)
			duration: 0,
			//考试剩余时间
			remainingTime: null,
			//考试开始时间
			startTime: 0,
			//考试结束时间
			endTime: 0,
			//当前时间
            currentTime: 0,
            examTimes: 0
		};
	},
	methods: {
		examPaperData() {
			this.examId = this.$route.query.id;
			this.$axiosPackag.getMessageByAxios("GET", "/api/student/onlineExam/previewExamination", { examinationId: this.examId }, null, null, (res) => {
				this.examPaperList = res;
				this.totalScore = res.totalScore; //总分
				res.questionTypeSummaries.forEach((element) => {
					this.totalQutestionNumber += element.totalNumbers; //总题目数
				});
                this.questionTypeSummaries = res.questionTypeSummaries;
				//考试总时长  分钟
                this.duration = parseInt(res.duration);
                this.examTimes = res.examTimes;
				//剩余时长   毫秒级别
				this.remainingTime = res.remainingTime;
				//直接调用开始考试
				for (var i = 0; i < this.questionTypeSummaries.length; i++) {
					for (var j = 0; j < this.questionTypeSummaries[i].questions.length; j++) {
						var question = this.questionTypeSummaries[i].questions[j];
						var nandu = "";
						if (question.level == "003001") {
							nandu = "简单";
							this.jiandannumber++;
						}
						if (question.level == "003002") {
							nandu = "普通";
							this.putongnumber++;
						}
						if (question.level == "003003") {
							nandu = "困难";
							this.kunnannumber++;
						}
						question.content = "(" + nandu + ")" + this.$util.html(question.content) + "(" + question.score + "分)";
						question.analysis = this.$util.html(question.analysis);
						question.answer = this.$util.html(question.answer);
						if (question.choices) {
							for (var q = 0; q < question.choices.length; q++) {
								question.choices[q].content = this.$util.html(question.choices[q].content);
							}
						}
						if (question.blanksNumber) {
							let blanksNumber = parseInt(question.blanksNumber);
							question.blanksNumbers = [];
							for (let f = 0; f < blanksNumber; f++) {
								let op = {};
								op.userAnswer = [];
								question.blanksNumbers.push(op);
							}
						}
						if (question.type == "001001") {
							this.questionList1.push(question);
						} else if (question.type == "001002") {
							// debugger
							question.userAnswer = question.userAnswer ? question.userAnswer.split(",") : [];
							// console.log( question,1111)
							// console.log( question.userAnswer,2222)
							this.questionList2.push(question);
						} else if (question.type == "001003") {
							this.questionList3.push(question);
						} else if (question.type == "001004") {
							this.questionList4.push(question);
						} else if (question.type == "001005") {
							this.questionList5.push(question);
						} else if (question.type == "001006") {
							this.questionList6.push(question);
						}
						this.questionDescription[question.type] = this.questionTypeSummaries[i].description;
					}
				}
			});
		},
		handleCheckedCitiesChange(value) {
			for (var i = 0; i < this.questionList2.length; i++) {
				this.$set(this.questionList2, i, this.questionList2[i]);
			}

			// debugger
			console.log(value);
		},
		menuBtn(type) {
			this.type = type;
		},
		menuBtns(types) {
			this.types = types;
		},
	},
	components: {
		headTop,
		ft,
		CountDown,
	},
	mounted() {
		this.examPaperData();
		// this.$axiosPackag.getMessageByAxios("GET", "/api/student/user/getUser", null, null, null, resD => {
		//   if (resD) {
		//     this.realName = resD.realName;
		//     this.userHeadImagUrl = resD.picture;
		//   }
		// });
		console.log(this.questionList2);
	},
};
</script>
<style scoped>
.el-checkbox-group span {
	color: #666 !important;
	font-size: 14px;
	font-family: "宋体";
}

.el-checkbox-group .el-checkbox__label {
	display: inline !important;
}
.paperIntroduce{
    letter-spacing: 2px;
}
.exam-content{
   overflow: inherit;
}
.exam-left{
    height: auto;
}
.examOverscroll{
    overflow-y: inherit;
}
</style>



// WEBPACK FOOTER //
// ExamPaperPreview.vue?778700f0